import React from 'react'

import { Text, Box } from '@mindfulchefuk/design-system'

interface LoggedInUserTitleProps {
  email: string
}

export const LoggedInUserTitle = ({ email }: LoggedInUserTitleProps) => (
  <Box>
    <Text as="h3" variant="heading-lg" mb={16}>
      Nearly there! Please review your purchase
    </Text>
    <Text
      as="p"
      variant="body-md"
      data-testid="user-details-already-present-message"
    >
      We&apos;ll send a confirmation to you at {email}
    </Text>
  </Box>
)
